/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Select_File_LabelInputs */

const en_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Marker File`)
};

const fr_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le fichier de marqueurs`)
};

const de_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerdatei auswählen`)
};

const it_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona file marcatore`)
};

const ru_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл маркера`)
};

const es_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo de marcador`)
};

const zh_cn2_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择标记文件`)
};

const ja_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーファイルを選択`)
};

const hi_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर फ़ाइल का चयन करें`)
};

const pt_pt2_marker_import_select_file_label = /** @type {(inputs: Marker_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar arquivo marcador`)
};

/**
* | output |
* | --- |
* | "Select Marker File" |
*
* @param {Marker_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_select_file_label = /** @type {((inputs?: Marker_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_select_file_label(inputs)
	if (locale === "de") return de_marker_import_select_file_label(inputs)
	if (locale === "it") return it_marker_import_select_file_label(inputs)
	if (locale === "ru") return ru_marker_import_select_file_label(inputs)
	if (locale === "es") return es_marker_import_select_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_select_file_label(inputs)
	if (locale === "ja") return ja_marker_import_select_file_label(inputs)
	if (locale === "hi") return hi_marker_import_select_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_select_file_label(inputs)
	return en_marker_import_select_file_label(inputs)
});